<!-- container-xxl -->
<div class="content-wrapper resource-content-wrapper p-0">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="content-body content-body-outer-img-container">
        <img src="assets\images\resources\Group 162.png" alt="about-us">
    </div>
    <div class="content-body">
        <!-- app e-commerce details start -->
        <section class="app-ecommerce-details">

            <div class="row justify-content-around">
                <div class="col-8 justify-content-around d-flex flex-wrap">
                    <div class="col-4 text-sm-left border pt-1 mt-3 mb-3">
                        <div class="card-header">
                            <h3>Highlights of Our Work</h3>
                        </div>
                        <div class="card-body">
                        <p><a target="-blank"
                                   href="{{documentURL}}/highlights_of_our_work/MNRE_R&D_Highlights_2022-2023.pdf"
                                        class="link"> MNRE R&D Highlights 2022-2023 </a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/highlights_of_our_work/MNRE_R&D_Highlights_2021-2022.pdf"
                                    class="link"> MNRE R&D Highlights 2021-2022 </a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/highlights_of_our_work/MNRE_R&D_Highlights_2020-2021.pdf"
                                    class="link"> MNRE R&D Highlights 2020-2021 </a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/highlights_of_our_work/MNRE_R&D_Highlights_2019-2020.pdf"
                                    class="link"> MNRE R&D Highlights 2019-2020 </a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/highlights_of_our_work/MNRE_R&D_Highlights_2018-2019.pdf"
                                    class="link"> MNRE R&D Highlights 2018-2019 </a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/highlights_of_our_work/MNRE_R&D_Highlights_2017-2018.pdf"
                                    class="link"> MNRE R&D Highlights 2017-2018 </a></p>
                        </div>
                    </div>
                    <div class="col-4 text-sm-left border pt-1 mt-3 mb-3">
                        <div class="card-header">
                            <h3>MNRE R&D Policy</h3>
                        </div>
                        <div class="card-body">
                                <p><a target="-blank"
                                        href="{{documentURL}}/MNRE_R&D_policy/MNRE_R&D_RE_RTD_Policy_2021.pdf"
                                        class="link"> MNRE R&D Policy Signed 2021</a> </p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/MNRE_R&D_policy/MNRE_R&D_Policy_Signed2019.pdf"
                                    class="link"> MNRE R&D Policy Signed 2019</a> </p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/MNRE_R&D_policy/MNRE_R&D_Policy2010.pdf"
                                    class="link"> MNRE R&D Policy 2010 </a> </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-around">
                <div class="col-8  justify-content-around d-flex flex-wrap">
                    <div class="col-4 text-sm-left border pt-1 mb-3">
                        <div class="card-header">
                            <h3>Project Publications</h3>
                        </div>
                        <div class="card-body">
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/All_India_Survey_of_Photovoltaic_Module_Reliability_2018_Report.pdf"
                                    class="link">All India Survey of Photovoltaic Module Reliability 2018 Report</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/All_India_Survey_of_Photovoltaic_Module_Reliability_2016_Executive_Summary.pdf"
                                    class="link">All India Survey of Photovoltaic Module Reliability 2016 Executive
                                    Summary</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/NCPRE_Summary_of_Achievements_2010-2015.pdf"
                                    class="link">NCPRE Summary of Achievements 2010-2015</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/All_India_Survey_of_Photovoltaic_Module_Degradation_2013.pdf"
                                    class="link">All India Survey of Photovoltaic Module Degradation 2013</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/Data_Analysis_Report_NIWE_Integrated_Resource_Assessment.pdf"
                                    class="link">Data Analysis Report (2) NIWE Integrated Resource Assessment</a></p>
                            <p><a target="-blank" href="
                            {{documentURL}}/publications/India's_Wind_Potential_Atlas_at_120m_agl.pdf"
                                    class="link">India's Wind Potential Atlas at 120m agl</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/Lidar_validation_report_final.pdf"
                                    class="link">Lidar validation report final</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/Met_Ocean_NIWE.pdf"
                                    class="link">Met Ocean NIWE</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/Paper_Comparison_of_Structural_Aspects_of_Monopile_and_Tripile_for_offshore_observation_platforms_v5.pdf"
                                    class="link">Paper Comparison of Structural Aspects of Monopile and Tripile
                                    for offshore observation platforms v5(1) (1)</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/publications/Solar_PV_Water_Pumps_Testing_Guidelines_developed_by_NISE_through_MNRE_Support.pdf"
                                    class="link">Solar PV Water Pumps Testing Guidelines developed by NISE through
                                    MNRE Support</a></p>
                            <p><a target="-blank" href="{{documentURL}}/publications/URLs.docx"
                                    class="link">URLs</a></p>

                            <!-- <p><a target="-blank" href="" class="link"> All India Survey of Photovoltaic Module Degradation 2013</a> </p>
                        <p><a target="-blank" href="" class="link"> All India Survey of Photovoltaic Module Reliability 2016 Executive Summary</a></p>
                        <p><a target="-blank" href="" class="link"> All India Survey of Photovoltaic Module Reliability 2018 Report </a></p>
                        <p><a target="-blank" href="" class="link"> Data Analysis Report <br> (2) Niwe Integrated Resource Assessment </a></p>
                        <p><a target="-blank" href="" class="link"> India's Wind Potential Atlas at 120m agl</a> </p> -->
                        </div>
                    </div>
                    <div class="col-4 text-sm-left border pt-1 mb-3">
                        <div class="card-header">
                            <h3>R&D Division Reports</h3>
                        </div>
                        <div class="card-body">
                            <p><a target="-blank"
                                    href="{{documentURL}}/R&D_division_reports/Background_Note_MNRE-GIZ_ISUN_Project.pdf"
                                    class="link">Background Note MNRE-GIZ ISUN Project</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/R&D_division_reports/Final_MoM_for_Review_of_RD_scheme_MNRE.pdf"
                                    class="link">Final MoM for Review of RD scheme MNRE</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/R&D_division_reports/MNRE-GIZ_I-SUN_Project_Overview.pdf"
                                    class="link">MNRE-GIZ I-SUN Project Overview</a></p>
                            <p><a target="-blank"
                                    href="{{documentURL}}/R&D_division_reports/R&D_Review_Report.pdf"
                                    class="link">R&D Review Report</a></p>
                                    
                            <!-- <p><a href="" class="link"> All India Survey of Photovoltaic Module Reliability 2018 Report </a></p>
                        <p><a href="" class="link"> All India Survey of Photovoltaic Module Reliability 2016 Executive Summary</a></p>
                        <p><a href="" class="link"> All India Survey of Photovoltaic Module Degradation 2013</a></p>
                        <p><a href="" class="link"> Data Analysis Report <br> (2) Niwe Integrated Resource Assessment </a></p>
                        <p><a href="" class="link"> India's Wind Potential Atlas at 120m agl</a></p> -->
                        </div>
                    </div>
                    <div class="col-4 text-sm-left border pt-1 mb-3">
                        <div class="card-header">
                            <h3>Important Links</h3>
                        </div>
                        <div class="card-body">
                            <p><a target="-blank"
                                    href="https://testing.nise.res.in/testing-of-solar-pumps"
                                    class="link">MNRE Supported State-of-the-Art Solar Water Pump Testing and R&D Facility at NISE (NABL accredited)</a></p>
                            <p><a target="-blank"
                                    href="http://www.ncpre.iitb.ac.in/ncpre/research/reports.html"
                                    class="link">NCPRE Reports</a></p>
                            <p><a target="-blank"
                                    href="https://niwe.res.in/department_wra_100m%20agl.php"
                                    class="link">NIWE Offshore Wind Potential Map at 100 m hub height</a></p>
                            <p><a target="-blank"
                                    href="https://maps.niwe.res.in/resource_map/map/150m/"
                                    class="link">Wind Potential Map at 150m above ground level (agl)</a></p>
                                    <p><a target="-blank"
                                        href="https://maps.niwe.res.in/resource_map/map/hybrid/"
                                        class="link">Integrated wind-solar hybrid map by NIWE based on the National Wind-Solar Hybrid Policy 2018</a></p>
                            <!-- <p><a href="" class="link"> All India Survey of Photovoltaic Module Reliability 2018 Report </a></p>
                        <p><a href="" class="link"> All India Survey of Photovoltaic Module Reliability 2016 Executive Summary</a></p>
                        <p><a href="" class="link"> All India Survey of Photovoltaic Module Degradation 2013</a></p>
                        <p><a href="" class="link"> Data Analysis Report <br> (2) Niwe Integrated Resource Assessment </a></p>
                        <p><a href="" class="link"> India's Wind Potential Atlas at 120m agl</a></p> -->
                        </div>
                    </div>

                    <div class="col-4 text-sm-left border pt-1 mb-3">
                        <div class="card-header">
                            <h3>Newsletter</h3>
                        </div>
                        <div class="card-body">
                            <p><a target="-blank"
                                href="{{documentURL}}/R&D_division_reports/Newsletter_MNRE_R&D_Division_Dec_2022.pdf"
                                class="link">Newsletter MNRE R&D Division Dec 2022</a></p>
                                <p><a target="-blank"
                                        href="{{documentURL}}/R&D_division_reports/Newsletter_MNRE_R&D_Division_Dec_2021.pdf"
                                        class="link">Newsletter MNRE R&D Division Dec 2021</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</div>